import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import goEMed from 'assets/images/partners/goEMed_logo.jpg';
import abhilasha from 'assets/images/partners/abhilasha.png';

const partnerImages = [goEMed, abhilasha];

const Partners = () => {
	const theme = useTheme();
	return (
		<Box>
			<Grid container spacing={2}>
				<Grid item xs={12} md={12}>
					<Box display='flex' flexDirection={'row'} justifyContent={'center'} alignContent={'center'}>
						<SimTypography variant={'h4'} gutterBottom sx={{ fontWeight: 700 }}>
							We are trusted by partners globally
						</SimTypography>
					</Box>
				</Grid>
				<Grid item xs={12} md={12}>
					<Box
						display='flex'
						flexDirection={'row'}
						justifyContent={'center'}
						alignContent={'center'}
						margin={0}
						padding={0}>
						<SimTypography variant={'h6'} component={'p'} color={'text.secondary'}>
							Our partners are noted institutions that boost our depth of care
						</SimTypography>
					</Box>
				</Grid>
				<Grid item xs={12} md={12}>
					<Box>
						<Box
							display='flex'
							flexDirection={{ xs: 'column', md: 'row' }}
							justifyContent={'center'}
							alignContent={'center'}>
							{partnerImages.map((item, i) => (
								<Box alignSelf={'center'} paddingY={2} paddingX={4} key={i}>
									<Box
										component='img'
										height={'auto'}
										width={'auto'}
										maxWidth={'150px'}
										src={item}
										alt='...'
										sx={{
											filter: theme.palette.mode === 'dark' ? 'brightness(0) invert(0.7)' : 'none'
										}}
									/>
								</Box>
							))}
						</Box>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default Partners;
